import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useLogout } from "../../features/UserAuthentication/api";
import { toast } from "react-toastify";
import burgerMenuIcon from "../../assets/burger_menu_icon.svg";
import useBurgerMenu from "../../hooks/burgerMenuState";
import signoutIcon from "../../assets/signout_icon.svg";
import webcrawlerChatbotLogo from "../../assets/webcrawlerchatbot_logo.jpg";

export default function Navbar() {
  const location = useLocation();
  const path = location.pathname;

  // For Profile highlight
  const isProfile = path.startsWith("/profile");
  // For Dashboard highlight
  const isDashboard = path.startsWith("/dashboard");
  // For Chatbot highlight
  const isChatbot = path.startsWith("/chatbot");
  const logoutMutation = useLogout();
  const navigate = useNavigate();
  const [serverError, setServerError] = useState("");

  const { isMenuOpen, toggleMenu, close } = useBurgerMenu();

  const handleLogout = async () => {
    await logoutMutation.mutateAsync(undefined, {
      onSuccess: () => {
        // Optionally, you can show a success message or redirect
        toast.success("Successfully logged out", {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: true,
        });
        navigate("/log-in");
      },
      onError: (err: any) => {
        // Handle error if needed
        setServerError(
          err.response?.data?.message || "An error occurred during logout"
        );
      },
    });
  };

  useEffect(() => {
    if (serverError) toast.error(serverError);
  }, [serverError]);

  const [isLargeScreen, setIsLargeScreen] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia("(min-width: 768px)");
    setIsLargeScreen(mediaQuery.matches);

    const handleResize = () => {
      setIsLargeScreen(mediaQuery.matches);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div className='bg-white w-full'>
      <div className='h-20 flex items-center justify-between p-7 fixed bg-white top-0 left-0 right-0 z-30'>
        <div className='flex items-center py-2 md:py-4'>
          <a href='/dashboard' className='flex items-center'>
            <img
              src={webcrawlerChatbotLogo}
              alt='Logo'
              className='h-16 md:h-20 lg:h-24'
            />
            <p className='font-bold ml-2 md:ml-4 text-xs md:text-sm lg:text-base '>
              Excelitte Web Crawler Chatbot
            </p>
          </a>
        </div>
        {isLargeScreen ? (
          <div className='invisible md:visible'>
            <nav className='flex items-center space-x-8'>
              <Link
                style={{
                  color: isProfile ? `#FF5F02` : "inherit",
                  fontWeight: isProfile ? "bold" : "normal",
                }}
                to='/profile'
              >
                Profile
              </Link>
              <Link
                style={{
                  color: isDashboard ? `#FF5F02` : "inherit",
                  fontWeight: isDashboard ? "bold" : "normal",
                }}
                to='/dashboard'
              >
                Dashboard
              </Link>
              <Link
                style={{
                  color: isChatbot ? `#FF5F02` : "inherit",
                  fontWeight: isChatbot ? "bold" : "normal",
                }}
                to='/chatbot'
              >
                Chatbot
              </Link>
              <button
                onClick={handleLogout}
                disabled={logoutMutation.isPending}
                className='flex items-center text-white bg-red-500 border-none cursor-pointer rounded-md p-2 hover:bg-red-700 transition-colors duration-300'
                type='button'
              >
                <img src={signoutIcon} alt='Sign Out' className='w-5 h-5 inline mr-1' />
                {logoutMutation.isPending ? "Signing out..." : "Sign Out"}
              </button>
            </nav>
          </div>
        ) : (
          <img
            src={burgerMenuIcon}
            alt='Menu'
            className='w-6 h-6 cursor-pointer'
            onClick={() => toggleMenu()}
          />
        )}
      </div>
      {!isLargeScreen && isMenuOpen && (
        <div className='fixed z-30 bg-white w-full pb-2'>
          <nav className='flex flex-col justify-center items-center'>
            <Link
              style={{ color: isProfile ? `#FF5F02` : "inherit" }}
              to='/profile'
              className='w-full hover:bg-gray-50 p-2 text-center'
              onClick={() => close()}
            >
              Profile
            </Link>
            <Link
              style={{
                color: isDashboard ? `#FF5F02` : "inherit",
              }}
              to='/dashboard'
              className='w-full hover:bg-gray-50 p-2 text-center'
              onClick={() => close()}
            >
              Dashboard
            </Link>
            <Link
              style={{ color: isChatbot ? `#FF5F02` : "inherit" }}
              to='/chatbot'
              className='w-full hover:bg-gray-50 p-2 text-center'
              onClick={() => close()}
            >
              Chatbot
            </Link>
            <button
                onClick={handleLogout}
                disabled={logoutMutation.isPending}
                className='flex items-center text-white bg-red-500 border-none cursor-pointer rounded-md p-2 hover:bg-red-700 transition-colors duration-300'
                type='button'
              >
                <img src={signoutIcon} alt='Sign Out' className='w-5 h-5 inline mr-1' />
                {logoutMutation.isPending ? "Signing out..." : "Sign Out"}
              </button>
          </nav>
        </div>
      )}
    </div>
  );
}
